module.exports = __webpack_public_path__ + "img/2.95ba8063.png";